import Footer from "../../components/footer/footer";
import Header from "../../components/header/header";
import { Link } from "react-router-dom";
import ButtonOne from "../../components/buttons/buttonOne";
import { motion } from "framer-motion";

export default function About() {
    const profiles = [
        {
            name: "Joseph Casebeer",
            role: "Founder",
            image: "/images/team/joseph.webp",
            linkedin: "https://linkedin.com/in/joseph-casebeer/",
        },
        {
            name: "Paul Nam",
            role: "Software Developer",
            image: "/images/team/paul.webp",
            linkedin: "https://linkedin.com/in/paul-nam/",
        },
        {
            name: "Sakura Watanabe",
            role: "Graphics Designer",
            image: "/images/team/sakura.webp",
            linkedin: "https://linkedin.com/in/sakura-watanabe-/",
        },
        {
            name: "Emilio Ganchorre",
            role: "Marketer",
            image: "/images/team/emilio.jpg",
            // linkedin: "https://linkedin.com/in/clairemori",
        },

    ];

    return (
        <div className="flex flex-col w-full h-full items-center justify-center">
            <Header />
            <div className="flex flex-col w-full min-h-screen items-center justify-center gap-y-[3rem] bg-black py-[5rem] text-white">
                <div className="flex flex-col justify-start items-start w-[80%] xl:w-[70%] gap-y-[2rem] text-xl">
                    <h1 className="text-4xl">
                        OUR <span className="text-[#2FC1E2]">MISSION</span>
                    </h1>
                    <p>
                        At Takamori Robot, our mission is to make robotics education more accessible by providing affordable kits that bridge the gap between theoretical learning and real-world application.
                    </p> 
                    {/* line between the decor section */}
                    <motion.hr 
                        className="w-full my-4 lg:my-12 h-[1px] border-0 bg-gradient-to-r from-transparent via-black to-transparent dark:via-neutral-400"
                        initial={{ y: 100, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.4 }}
                    />
                    <h2 className="text-4xl">
                        OUR <span className="text-[#2FC1E2]">GOAL</span>
                    </h2>
                    <p>
                        We aim to empower students, educators, and makers with hands-on tools that inspire exploration, foster creativity, and build a strong foundation in robotics and engineering.
                    </p> 
                </div>

                {/* line between the decor section */}
                <motion.hr 
                    className="w-[80%] my-4 lg:my-12 h-[1px] border-0 bg-gradient-to-r from-transparent via-black to-transparent dark:via-neutral-400"
                    initial={{ y: 100, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    viewport={{ once: true, amount: 0.4 }}
                />

                <div className="flex justify-start items-start text-white w-[80%] xl:w-[70%]">
                    <h2 className="text-4xl">OUR <span className="text-[#2FC1E2]">INSPIRATION</span></h2>
                </div>
                
                <div className="flex flex-col xl:flex-row justify-center items-center xl:w-[70%]">
                    <div className="flex flex-col gap-y-[1rem] w-[80%] xl:w-[50%]">
                        <h3 className="font-bold text-3xl">
                            H.I.R.O - Model TR-01-A
                        </h3>
                        <p>
                            Model TR-01-A is our very first robotics kit, designed using the Raspberry Pi Pico.
                        </p>
                        <p>
                            This kit was inspired by our mission to make robotics more accessible and engaging for students, hobbyists, and makers eager to explore the world of robotics.
                        </p>
                        <p>
                            Every aspect of the design is handcrafted and carefully refined through multiple iterations to ensure both quality and ease of use.
                        </p>
                    </div>
                    <img
                        src="/images/product/firstkit_product.webp"
                        alt="Takamori FirstKit"
                        className="w-[80%] xl:w-[50%] max-w-l h-auto"
                    />
                </div>
                <div className="flex flex-col xl:flex-row justify-center items-center w-[80%] xl:w-[70%] h-full">
                    <img
                        src="/images/product/firstkit_PCB.webp"
                        alt="Takamori FirstKit"
                        className="xl:w-[50%] max-w-l h-auto"
                    />
                    <div className="flex flex-col gap-y-[1rem] w-[80%] xl:w-[50%] xl:ml-[3rem]">
                        <h3 className="font-bold text-3xl">
                            Design Robotics with Us
                        </h3>
                        <p>
                            We are dedicated to sharing our knowledge on how to design robots from the ground up.
                        </p>
                        <p>
                            Join us as we explore and learn about robotics together.
                        </p>
                        <Link to="/robotics-kits">
                            <ButtonOne 
                                position=""
                            >
                                Robotic Kits
                            </ButtonOne>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="flex flex-col w-[70%] md:w-[60%] lg:w-[45%] h-full items-top justify-start gap-y-[2rem] mt-[5rem]">
                <h2 className="font-bold text-2xl">Meet Our Team</h2>
                
                <p className="w-[80%] lg:w-[50%]">The goal and mission of Takamori Robot is to provide affordable, modular, and customizable robotics kits for everyone.</p>
                
                {/* Team grid */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-[5rem] gap-x-[2rem]">
                {profiles.map((profile, index) => (
                    <div key={index} className="flex flex-row items-center space-x-4">
                        <img
                            src={profile.image}
                            alt={profile.name}
                            className="w-32 h-32 rounded-full object-cover"
                        />
                        <div className="flex flex-col">
                            <p className="font-semibold">{profile.name}</p>
                            <p className="text-sm text-gray-500">{profile.role}</p>
                            <a
                                href={profile.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 hover:underline text-sm"
                            >
                                LinkedIn
                            </a>
                        </div>
                    </div>
                ))}
                </div>
            </div>
            <Footer />
        </div>

    )
}